import { api } from "@api/api";
import { Promocode } from "@modules/promocodes/types";
import { PromocodeFormValues } from "@modules/promocodes/validations";

export async function createPromocodeService(data: PromocodeFormValues): Promise<Promocode> {
  const { data: promocode } = await api.post<Promocode>("v1/promocode_admin/", data);

  return promocode;
}
